import { RefinementBar } from "./RefinementBar";
import { registerNextBestAction } from "../nextBestAction/NextBestActionComponent";
import { events } from "../events";
import { registerFilterPersonalizationEventHandlers } from "../filterPersonalization/filterPersonalization";

export function registerRefinementBar() {
  registerNextBestAction();
  registerFilterPersonalizationEventHandlers();
  registerRefinementBarInit();
  registerRefinementBarLocking();
}

function registerRefinementBarInit() {
  events.onFilterSectionLoaded(RefinementBar.initAll);
}

function registerRefinementBarLocking() {
  /*      */
  events.onFilterSectionLoad(RefinementBar.lockAll);
  /*        */
  events.onRefinementBarLoaded(RefinementBar.unlockAll);
}
